import qs from "qs";

export const productDomainEnum = {
  dmp: "dynamed.com",
  dmx: "dynamedex.com",
  dhe: "dynahealth.com",
};

export const DOMAIN_LIST = Object.values(productDomainEnum);
export const DOMAIN_LIST_WITH_WEB_PREFIX = DOMAIN_LIST.map(
  (domain) => `www.${domain}`
);

export const isProxyUser = (hostname) =>
  !DOMAIN_LIST.includes(hostname) &&
  !DOMAIN_LIST_WITH_WEB_PREFIX.includes(hostname);

export const buildShareUrlForProxyUser = (productCode, contentUrlData) => {
  const { origin, pubType, slug } = contentUrlData;
  return {
    internalShareLink: `${origin}/${pubType}/${slug}`,
    externalShareLink: `https://${productDomainEnum[productCode]}/${pubType}/${slug}`,
  };
};

export const buildShareUrlForNonProxyUser = (
  productCode,
  contentUrlData,
  shareDetailsData
) => {
  const { origin, pubType, slug } = contentUrlData;
  const { cust } = shareDetailsData;

  const shareLinks = {
    externalShareLink: `${origin}/${pubType}/${slug}`,
  };

  if (cust) {
    shareLinks.internalShareLink = `https://${
      productDomainEnum[productCode]
    }?${qs.stringify(shareDetailsData)}&returnToUrl=https://${
      productDomainEnum[productCode]
    }/${pubType}/${slug}`;
  }

  return shareLinks;
};
